import { formatInTimeZone } from "date-fns-tz";
import { es } from "date-fns/locale";

export const formatEventDate = (eventDate) => {
  return formatInTimeZone(
    eventDate,
    "America/Bogota",
    "EEEE, dd 'de' MMMM 'de' yyyy h:mm aaaa",
    { locale: es }
  );
};
